import { render, staticRenderFns } from "./vcText.vue?vue&type=template&id=4582f798&"
import script from "./vcText.vue?vue&type=script&lang=js&"
export * from "./vcText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports